import React from "react";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChart = ({ data, currency }) => {
  const options = {
    responsive: true,
    //   maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.raw;
            return currency ? `${currency}${value}` : value;
          },
        },
      },
    },
    scales:{
        x:{
            grid:{
                drawOnChartArea: false,
            }
        },
        y:{
            display: false,
            grid:{
                drawOnChartArea: false,
            }
        },
    }
  };

  return <Bar data={data} options={options} />;
};

export default BarChart;
